import { render, staticRenderFns } from "./InvoiceDetailsGrid.vue?vue&type=template&id=27c8b1d3"
import script from "./InvoiceDetailsGrid.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsGrid.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailsGrid.vue?vue&type=style&index=0&id=27c8b1d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports